module.exports = __webpack_public_path__ + "img/signbutton2.c85f8537.png";